import React from 'react';
export const BoxGreyed = () => (
  <svg width="82px" height="106px" viewBox="0 0 82 106" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-854.000000, -2086.000000)">
        <g transform="translate(854.000000, 2086.000000)">
          <path
            d="M33.6099,13.1088 L33.6099,15.4908"
            stroke="#C3D3D8"
            strokeLinecap="round"
          />
          <path
            d="M33.6099,20.2543 L33.6099,22.6363"
            stroke="#C3D3D8"
            strokeLinecap="round"
          />
          <path
            d="M38.3736,17.8725 L35.9916,17.8725"
            stroke="#C3D3D8"
            strokeLinecap="round"
          />
          <path
            d="M31.2281,17.8725 L28.8461,17.8725"
            stroke="#C3D3D8"
            strokeLinecap="round"
          />
          <path
            d="M65.6485,22.6361 L65.6485,24.7201"
            stroke="#C3D3D8"
            strokeLinecap="round"
          />
          <path
            d="M65.6485,28.8891 L65.6485,30.9731"
            stroke="#C3D3D8"
            strokeLinecap="round"
          />
          <path
            d="M69.817,26.8041 L67.733,26.8041"
            stroke="#C3D3D8"
            strokeLinecap="round"
          />
          <path
            d="M63.5645,26.8041 L61.4805,26.8041"
            stroke="#C3D3D8"
            strokeLinecap="round"
          />
          <path
            d="M20.9654,2.7348 C20.9654,3.7338 20.1554,4.5438 19.1574,4.5438 C18.1594,4.5438 17.3494,3.7338 17.3494,2.7348 C17.3494,1.7368 18.1594,0.9268 19.1574,0.9268 C20.1554,0.9268 20.9654,1.7368 20.9654,2.7348 Z"
            stroke="#C3D3D8"
          />
          <path
            d="M46.8511,40.6049 C46.8511,41.6029 46.0411,42.4129 45.0431,42.4129 C44.0451,42.4129 43.2351,41.6029 43.2351,40.6049 C43.2351,39.6059 44.0451,38.7969 45.0431,38.7969 C46.0411,38.7969 46.8511,39.6059 46.8511,40.6049 Z"
            stroke="#C3D3D8"
          />
          <path
            d="M78.9639,99.683 C78.9639,102.967 68.0609,105.629 54.6119,105.629 C41.1629,105.629 30.2599,102.967 30.2599,99.683 C30.2599,96.399 41.1629,93.737 54.6119,93.737 C68.0609,93.737 78.9639,96.399 78.9639,99.683"
            fill="#F3F4F6"
          />
          <polygon
            fill="#FCFCFC"
            points="51.397 104.2699 9.123 98.2639 9.123 59.1519 51.397 63.4169"
          />
          <polygon
            stroke="#C3D3D8"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="51.397 104.2699 9.123 98.2639 9.123 59.1519 51.397 63.4169"
          />
          <polygon
            fill="#F3F4F6"
            points="72.712 95.1361 51.397 104.2701 51.397 63.4171 72.712 56.3081"
          />
          <polygon
            stroke="#C3D3D8"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="72.712 95.1361 51.397 104.2701 51.397 63.4171 72.712 56.3081"
          />
          <polygon
            fill="#F3F4F6"
            points="51.397 63.4174 9.123 59.1514 34.845 51.9314 34.731 61.7354"
          />
          <polygon
            stroke="#C3D3D8"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="51.397 63.4174 9.123 59.1514 34.845 51.9314 34.731 61.7354"
          />
          <polyline
            stroke="#C3D3D8"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="72.712 56.308 34.845 51.931 26.326 42.201 0.976 47.772 9.123 59.152"
          />
          <polygon
            fill="#FCFCFC"
            points="51.397 63.4174 62.054 49.3604 81.369 44.8514 72.712 56.3084"
          />
          <polygon
            stroke="#C3D3D8"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="51.397 63.4174 62.054 49.3604 81.369 44.8514 72.712 56.3084"
          />
          <polyline
            stroke="#C3D3D8"
            points="38.1309 62.0785 38.1309 74.3945 44.8619 75.3325 44.8619 62.7585"
          />
        </g>
      </g>
    </g>
  </svg>
);
